import { utils, writeFile } from 'xlsx';

const HEADERS = [
  'OPERATION_ID',
  'NAME',
  'CIF',
  'EMAIL',
  'PROPERTY_TYPE',
  'OPERATION_TYPE',
  'TOTAL_SHARES',
  'SHARE_FROM',
  'SHARE_TO',
  'DATE',
  'SHARE_PRICE',
  'ALIAS',
  'COMMENTS',
];

const SAMPLE_ROWS = [
  [
    'OP001',
    'Socio Vendedor',
    '12345678A',
    'vendedor@example.com',
    'PD',
    'SELL_PARTICIPATION',
    -100,
    1,
    100,
    '01/15/2024 0:00',
    5000,
    'OP_ALIAS_VENTA',
    'OP001',
  ],
  [
    'OP001',
    'Socio Comprador',
    '87654321B',
    'comprador@example.com',
    'PD',
    'SELL_PARTICIPATION',
    100,
    1,
    100,
    '01/15/2024 0:00',
    5000,
    'OP_ALIAS_COMPRA',
    'OP001',
  ],
];

export const downloadSharesTransferExcelTemplate = (): void => {
  const worksheet = utils.aoa_to_sheet([HEADERS, ...SAMPLE_ROWS]);
  const workbook = utils.book_new();

  utils.book_append_sheet(workbook, worksheet, 'Transacciones');
  writeFile(workbook, 'plantilla-transmisiones-masivas.xlsx');
};
